export const NotificationTypes = {
  types: {
    ERROR: "error",
    SUCCESS: "success"
  },
  cssClass: {
    ALERT_DANGER: "alert-danger",
    ALERT_PRIMARY: "alert-primary"
  }
};

export default NotificationTypes;
